export interface VectorIndexProfile {
  plugin_id: string;
  model_name: string;
  enabled: boolean;
  is_default: boolean;
  index_kinds: string[];
  dimension: number;
  distance_metric: string;
}

export interface MappingServiceViewModel {
  id: string;
  kind: string;
  pluginId: string;
  modelName: string;
  isDefault: boolean;
  indexKinds: string[];
  dimension: number;
  distanceMetric: string;
}

/**
 * Known mapping plugin identifiers. Single source of truth — reference these
 * instead of hard-coding the raw `rmi-topictree-*` strings anywhere else.
 */
export const MappingPluginId = {
  TechnicalManual: "rmi-topictree-tm-en",
  WdMapping: "rmi-topictree-wd-oem-de",
} as const;
export type MappingPluginId =
  (typeof MappingPluginId)[keyof typeof MappingPluginId];

export const PLUGIN_KIND_REGISTRY: Readonly<Record<string, string>> = {
  [MappingPluginId.TechnicalManual]: "technical-manual",
  [MappingPluginId.WdMapping]: "wd-mapping",
};

export const UNKNOWN_KIND = "unknown";
